import { SurveyJSON } from "Survey/types";

const json: SurveyJSON = {
  success: 'Færdig! Al information er afsendt',
  errors: {
    required: 'Udfyld venligst dette'
  },
  locales: {
    dk: {
      nextButton: 'Fortsæt',
      nextButtonHint: 'tryk <b>Enter ↵</b>',
      submitButton: 'Indsend',
      textAreaHint: '<b>Shift ⇧</b> + <b>Enter ↵</b> for linjeskift',
      invalidEmail: 'Email-adressen er ugyldig'
    }
  },
  defaultLocale: 'dk',
  items: [
    {
      type: 'custom',
      name: 'header',
      html: '<h3>Årsafslutningsskema - APS</h3>',
      buttonsAlign: 'left',
      buttons: ['next']
    },
    {
      type: 'input',
      name: 'stock',
      title: 'Lagerværdi',
      text:
        'Beskrivelse/eksempel: "Har du et færdigvarelager, så venligst oplys værdien af dine færdigvarer i danske kroner. ' +
        'Det skal være varelagerets værdi på regnskabsårets sidste dag. ' +
        'Værdien skal opgøres til indkøbsprisen eksklusiv moms. ' +
        'Hvis vi ikke får svar på dette inden fristen, går vi ud fra at du ikke har noget færdigvarelager, ' +
        'da det er sjældent at vores kunder har dette. ' +
        'Har du ikke lager, så skriv: Ingen lager."',
      required: false
    },
    {
       
      type: 'input',
      name: 'Kassebeholdning',
      title: 'Har du kassebeholdning, så skriv optalt kasse beløb på regnskabsårets sidste dag',
      text: 'Beskrivelse/eksempel: "Skriv beløbet der var i kassen på dit regnskabsår sidste dag."',
      required: false
      },
    {
    
      type: 'input',
      name: 'Udbytte',
      title: 'Ønsker du udbytte',
      text:
        'Beskrivelse/eksempel: "Hvis der er overskud i virksomheden, går vi ud fra, at du/I ønsker at tage det maksimale muligt ud i udbytte ' +
        'til den lave skatteprocent (27%). Beløbet er i 2025 67.500 kr. Skriv tilbage hvis du ikke ønsker dette. ' +
        'Hvis du ønsker udbytte, skriv også om du er gift eller ej, så vi kan udnytte den lave udbyttesats for jer begge (dvs. 2 x 67.500 kr). ' +
        'Hvis vi ikke hører noget, går vi ud fra, at du ikke er gift."',
      required: false
    },
    {
      type: 'custom',
      name: 'note_sambeskatning',
      html:
        '<blockquote>Er dette dit første regnskabsår, og du både har drift og holdingselskab, ' +
        'så vær sikker på at sambeskatningen er registreret korrekt mellem de to selskaber. ' +
        'Dette er dit ansvar og ikke noget vi kan gøre. ' +
        'Forkert registrering af sambeskatning eller manglende registrering kan medføre, ' +
        'at dit regnskab ikke kan nå at blive indberettet til indberetningsfristen. ' +
        'Tag kontakt til SKAT hvis du er i tvivl.</blockquote>',
      buttonsAlign: 'left',
      buttons: ['submit']
    }
  ]
};

export default json;
